import { useCallback, useEffect, useState } from 'react';

function readStoredCollapsed(storageKey: string, fallback: boolean): boolean {
    if (typeof window === 'undefined') return fallback;
    try {
        const raw = window.localStorage.getItem(storageKey);
        if (raw === null) return fallback;
        return raw === 'true';
    } catch {
        return fallback;
    }
}

function persistCollapsed(storageKey: string, value: boolean): void {
    if (typeof window === 'undefined') return;
    try {
        window.localStorage.setItem(storageKey, value ? 'true' : 'false');
    } catch {
        // localStorage may be unavailable (private mode, quota); fall through silently
    }
}

export interface UseSideRailCollapsedResult {
    collapsed: boolean;
    toggle: () => void;
}

export function useSideRailCollapsed(
    storageKey: string,
    defaultCollapsed: boolean
): UseSideRailCollapsedResult {
    const [collapsed, setCollapsed] = useState<boolean>(() =>
        readStoredCollapsed(storageKey, defaultCollapsed)
    );

    useEffect(() => {
        persistCollapsed(storageKey, collapsed);
    }, [storageKey, collapsed]);

    const toggle = useCallback(() => {
        setCollapsed((prev) => !prev);
    }, []);

    return { collapsed, toggle };
}
